/**
 *  renku-ui
 *
 *  utils/Docs.js
 *  Docs utils
 */

const READ_THE_DOCS_ROOT = "https://renku.readthedocs.io/en/stable";

const Docs = {
  READ_THE_DOCS_ROOT: READ_THE_DOCS_ROOT,
  READ_THE_DOCS_TUTORIALS: `${READ_THE_DOCS_ROOT}/tutorials`,
  // eslint-disable-next-line
  READ_THE_DOCS_TUTORIALS_STARTING: `${READ_THE_DOCS_ROOT}/tutorials/01_firststeps.html`,
};

const Links = {
  DISCOURSE: "https://renku.discourse.group",
  GITTER: "https://gitter.im/SwissDataScienceCenter/renku",
  GITHUB: "https://github.com/SwissDataScienceCenter/renku",
  HOMEPAGE: "https://datascience.ch",
  MASTODON: "https://fosstodon.org/@renku",
  YOUTUBE: "https://www.youtube.com/channel/UCMF2tBtWU1sKWvtPl_HpI4A",
  SDSC: "https://www.datascience.ch/",
  ETH: "https://ethrat.ch/en/",
  EPFL: "https://www.epfl.ch/en/",
  ETHZ: "https://ethz.ch/en.html",
  RENKU_BLOG: "https://blog.renkulab.io",
  RENKU_2_ADMIN_HOW_TO_GUIDE_INCIDENTS:
    "https://docs.renkulab.io/en/0.70.0/how-to-guides/admin/incidents-maintenance.html",
  RENKU_2_LEARN_MORE: "https://blog.renkulab.io/early-access",
  RENKU_2_SUNSET: "https://blog.renkulab.io/sunsetting-legacy/",
  RENKU_2_REGISTER_REDIRECT:
    "https://www.notion.so/renku/2540df2efafc80c5ac36c6ecf6a375a0?v=2540df2efafc80b1ae2b000cee3e5a3c#2540df2efafc80c5ac36c6ecf6a375a0",
};

export { Docs, Links };
